import { FileReader, FileWriter } from "@/platform";

class FontSetting {
  public Font: string = ""; //字体
  public FontSize: number = 12; //字号
  public Height: number = 16; // 字体高度

  constructor(param?: { f: string; size: number; h: number } | FileReader) {
    if (param && "f" in param) {
      const { f, size, h } = param;
      this.Font = f;
      this.FontSize = size;
      this.Height = h;
    } else if(param instanceof FileReader) {
      this.readBin(param as FileReader)
    } else {
      this.Font = "";
      this.FontSize = 12;
      this.Height = 16;
    }
  }

  readBin(reader: FileReader): void {
    this.Font = reader.readString()
    this.FontSize = reader.readInt()
    this.Height = reader.readInt()
  }

  writeBin(writer: FileWriter): void {
    writer.writeString(this.Font)
    writer.writeInt(this.FontSize)
    writer.writeInt(this.Height)
  }

  /**
   * 写入 Game.bin 运行时字体高度设置。
   */
  writeGameBin(writer: FileWriter): void {
    this.writeBin(writer)
  }
}
export default FontSetting;
